const app = {
  state: {
    newApp: true,
    showHeader: false,
    title: '',
    headerStyle: '',
    headerFixed: true,
    showBack: false,
    backText: '',
    backStyle: '',
    errorRequest: null,
    messageResponse: null,
  },
  getters: {
    newApp: state => state.newApp,
    showHeader: state => state.showHeader,
    title: state => state.title,
    headerStyle: state => state.headerStyle,
    headerFixed: state => state.headerFixed,
    showBack: state => state.showBack,
    backText: state => state.backText,
    backStyle: state => state.backStyle,
    errorRequest: state => state.errorRequest,
    messageResponse: state => state.messageResponse,
  },
  mutations: {
    SET_NEW_APP: (state, data) => {
      state.newApp = data;
    },
    SET_SHOW_HEADER: (state, data) => {
      state.showHeader = data;
    },
    SET_TITLE: (state, data) => {
      state.title = data;
    },
    SET_HEADER_STYLE: (state, data) => {
      state.headerStyle = data;
    },
    SET_HEADER_FIXED: (state, data) => {
      state.headerFixed = data;
    },
    SET_SHOW_BACK: (state, data) => {
      state.showBack = data;
    },
    SET_BACK_TEXT: (state, data) => {
      state.backText = data;
    },
    SET_BACK_STYLE: (state, data) => {
      state.backStyle = data;
    },
    SET_ERROR_REQUEST: (state, data) => {
      state.errorRequest = data;
    },
    SET_MESSAGE_RESPONSE: (state, data) => {
      state.messageResponse = data;
    },
  },
  actions: {
    toggleNewApp({ commit }, payload) {
      commit('SET_NEW_APP', payload);
    },
    toggleShowHeader({ commit }, payload) {
      commit('SET_SHOW_HEADER', payload);
    },
    changeTitle({ commit }, payload) {
      commit('SET_TITLE', payload);
    },
    updateHeaderStyle({ commit }, payload) {
      commit('SET_HEADER_STYLE', payload);
    },
    toggleHeaderFixed({ commit }, payload) {
      commit('SET_HEADER_FIXED', payload);
    },
    toggleShowBack({ commit }, payload) {
      commit('SET_SHOW_BACK', payload);
    },
    changeBackText({ commit }, payload) {
      commit('SET_BACK_TEXT', payload);
    },
    updateBackStyle({ commit }, payload) {
      commit('SET_BACK_STYLE', payload);
    },
    updateErrorRequest({ commit }, payload) {
      commit('SET_ERROR_REQUEST', payload);
    },
    updateMessageResponse({ commit }, payload) {
      commit('SET_MESSAGE_RESPONSE', payload);
    },
  },
};

export default app;
